import React from 'react';
import './EditForm.css'; // We'll define this next

const EditForm = ({ data, onChange, onCancel, onSubmit }) => {
  if (!data || typeof data !== 'object') return null;

  return (
    <div className="edit-form-wrapper">
      <div className="edit-form-card shadow rounded bg-white">
        <h4 className="text-center text-primary fw-bold mb-4 border-bottom pb-2">
          ✏️ Edit Asset Details
        </h4>

        <form onSubmit={onSubmit} className="row gx-4 gy-3">
          {Object.entries(data).map(([key, value]) => (
            <div className="col-md-6" key={key}>
              <label className="form-label text-capitalize">{key.replace(/_/g, ' ')}</label>
              <input
                type="text"
                name={key}
                value={value || ''}
                onChange={onChange}
                className="form-control"
                disabled={key === 'id'}
              />
            </div>
          ))}

         <div className="form-buttons">
            <button type="submit" className="btn btn-success">💾 Save</button>
            <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
            </div>
        </form>
      </div>
    </div>
  );
};

export default EditForm;
